import BackToTopButton from '../atoms/BackToTopButton';
import SelectLanguage from '../atoms/SelectLanguage';
import SelectFormat from '../atoms/SelectFormat';
import SelectOddsChanges from '../atoms/SelectOddsChanges';
import CMSFooterContent from '../atoms/CMSFooterContent';
import { Stack, Box } from '@mui/material';
import { useRoles } from '../../../../hooks/useRoles';

const styles = {
  container: {
    backgroundColor: 'neutral.600',
    p: 1.5,
  },
};

const Footer = () => {
  const { isPlayer } = useRoles();

  return (
    <Stack sx={styles.container}>
      <Box
        sx={{
          mb: 6,
        }}
      >
        <BackToTopButton />
      </Box>
      <SelectLanguage />
      {isPlayer && (
        <>
          <SelectFormat />
          <SelectOddsChanges />
        </>
      )}
      <CMSFooterContent />
    </Stack>
  );
};

export default Footer;
